import template   from './home.html'
import controller from './home.controller'

import './home.styl'

let component = {
  restrict: 'E',
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.js